



































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {i18nMixin} from '@/modules/neodash/mixins';
import {Getter} from 'vuex-class';
import {AUTH_GET_CLIENT} from '@/store/modules/authentication/types';
import {Client} from '@/store/modules/authentication/interfaces';
import Wrapper from '@/modules/business-plan/common/business-plan-page-wrapper.component.vue';

import TableComponent
  from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/table-goal-setting.component.vue';
import {salesTypes} from '../../../models/constants/salesTypes';
import {
  EconomicGroup,
  IEconomicGroupGoalsDetails,
  Families,
  FamilyMinValue, Project
} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/types';
import {ApprovalService} from '@/modules/business-plan/modules/services/approval.service';
import {GoalSettingColumns} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/GoalSettingColumns';
import {BPA_ROUTES} from '@/modules/business-plan/router';
import {SaleTypeEnum} from '@/modules/neodash/model/types/enums/saleTypeEnum';
import {notificationService, traceLogAccess} from '@/services';
import {AxiosError} from 'axios';
import {ContextEnum} from '@/enums/context.enum';

@Component({
  name: 'GoalSettingPage',
  components: {TableComponent, Wrapper}
})
export default class GoalSettingPage extends Vue {
  public readonly translate = i18nMixin.methods.i18n;
  public readonly salesTypes = salesTypes;
  public BPA_ROUTES = BPA_ROUTES;
  public project: Project = {} as Project;
  public families: Families = [];
  public validations: FamilyMinValue[] = new Array<FamilyMinValue>();
  public isValid: boolean = true;
  public hasError: boolean = false;
  public confirmNegotiate: boolean = false;
  public showMonthlyValues: boolean = false;
  public showGoalRealized: boolean = false;

  public economicGroup: EconomicGroup = {} as EconomicGroup;

  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Prop({required: true})
  public idProject: number;

  @Prop({required: true})
  public idGroup: number;

  @Prop({required: true})
  public idLocale: number;

  public get currentYear(): number {
    return this.project ? this.project.yearReference - 1 : 0;
  }

  public get isNegotiateConcluded(): boolean {
    return this.economicGroup.details && this.economicGroup.details.some(x => x.isNegotiateConcluded)
  }

  public get tables(): GoalSettingColumns[] {
    if (!this.families.length || !this.economicGroup.details.length)
      return [];

    return this.salesTypes
      .filter(x => x.isShow)
      .map(x => new GoalSettingColumns(this.project.yearReference, x, this.client))
  }

  public get titleGoalSetting(): string {
    const titles = ['Title', 'GoalSetting.Title']
      .map(x => this.translate(`BusinessPlan.${x}`))
      .join(' - ');

    return `${this.client.name} - ${titles}`;
  }

  public get familiesToCalcInclude(): number[]{
    return Array.from(this.families.filter(x => x.isCalcGoal), ({id}) => id);
  }

  public back() {
    this.$router.push({name: this.BPA_ROUTES.HOME});
  }

  // TODO: Improve this code.
  public saveGoalSettingsWithJustifications() {
    console.log(this.tables);
    if (this.isNegotiateConcluded)
      return false;

    const group = this.economicGroup;

    group.details = group.details.filter(x => x.idSaleType !== SaleTypeEnum.AllOfIt && this.familiesToCalcInclude.includes(x.idFamily));

    if (this.validations.map(x => x.justification).filter(x => !!x).length !== this.validations.length)
      return false;

    this.validations.forEach(rule => this.getDetailByRule(group.details, rule).justificationTotal = rule.justification);

    ApprovalService.SaveGoalSettings(this.idProject, group)
      .then(res => {
        this.hasError = false;
        this.confirmNegotiate = false;
        notificationService.sendToast({
          status: 1,
          type: 'success',
          message: 'Metas salvas com sucesso!'
        });
        this.hasError = false;
      })
      .catch((err: AxiosError) => console.error(err.message));
  }

  public saveGoalSettings(isNegotiateConcluded: boolean) {
    if (this.isNegotiateConcluded)
      return false;

    const group = {...this.economicGroup} as EconomicGroup;

    group.details = group.details.filter(x => x.idSaleType !== SaleTypeEnum.AllOfIt && this.familiesToCalcInclude.includes(x.idFamily));
    group.details.forEach(x => x.isNegotiateConcluded = isNegotiateConcluded);

    const hasJustification = group.details.some(x => x.justificationTotal) && isNegotiateConcluded;

    if (!hasJustification)
      if (!this.isValidGoal())
        return false;

    ApprovalService.SaveGoalSettings(this.idProject, group)
      .then(res => {
        this.hasError = false;
        this.confirmNegotiate = false;
        notificationService.sendToast({
          status: 1,
          type: 'success',
          message: 'Metas salvas com sucesso!'
        });
        this.hasError = false;
      })
      .catch((err: AxiosError) => console.error(err.message));
  }

  public openConfirmNegotiateModal() {
    this.confirmNegotiate = true;
  }

  public isValidGoal(): boolean {
    this.validations.length = 0;
    const rules = this.families
      .map(x => x.rules)
      .filter(x => x.length > 0)
      .flat();

    rules.forEach(rule => {
      const valueFamily = this.economicGroup.details.filter(x => x.idFamily === rule.idFamily && (x.idSaleType == rule.saleType || rule.saleType === SaleTypeEnum.AllOfIt)).sumBy(x => x.goalValue);
      const valueIndustry = this.economicGroup.details.filter(x => x.idFamily === rule.idFamily && (x.idSaleType == rule.saleType || rule.saleType === SaleTypeEnum.AllOfIt)).sumBy(x => x.industry.nextYear);

      if ((valueFamily / valueIndustry) < rule.valueMinimum) {
        rule.justification = this.getDetailByRule(this.economicGroup.details, rule).justificationTotal;

        this.validations.push(rule);
      }

    });

    this.hasError = this.validations.length > 0;
    return this.validations.length === 0;
  }

  public downloadPaccReport() {
    ApprovalService.DownloadBpaPacc('Ford_PACC', this.project.id, this.economicGroup);
  }

  public getGoalsDefinitionRealized(isGoalRealized){
    this.showGoalRealized = isGoalRealized;
          this.economicGroup.details.forEach((c,i) =>
          {
              c.sale.actualYear = isGoalRealized
              ? this.economicGroup.details[i].sale.actualYearRealized
              : this.economicGroup.details[i].sale.actualYearEstimated;

              c.industry.actualYear = isGoalRealized
              ? this.economicGroup.details[i].industry.actualYearRealized
              : this.economicGroup.details[i].industry.actualYearEstimated;
          });
  }

  public created() {
    const {GetProject, GetGoalDefinitionData, ListFamilies} = ApprovalService;

    Promise.all([GetProject(this.idProject), GetGoalDefinitionData(this.idProject, this.idGroup, this.idLocale), ListFamilies(this.idProject)])
        .then(([project, goalDefinition, families]) => {
          this.project = project;
          this.economicGroup = goalDefinition;
          this.families = families;

          if (!this.economicGroup.isEspecial) {
            this.families = this.families.filter(x => !x.isEspecial);
          }

          traceLogAccess.logAction(ContextEnum.Bpa, `Bpa Ford - Grupo Econômico`, JSON.stringify({...this.project, ...this.economicGroup}));
        });
  }

  private getDetailByRule(details: IEconomicGroupGoalsDetails[], rule: FamilyMinValue) {
    return details
      .filter(x => x.idFamily == rule.idFamily && (x.idSaleType == rule.saleType || rule.saleType === SaleTypeEnum.AllOfIt))
      .sortBy(x => x.goalValue)
      .reverse()[0];
  }

  private toggleErrorModal() {
    this.hasError = !this.hasError;
  }

  private toggleConfirmNegotiateModal() {
    this.confirmNegotiate = !this.confirmNegotiate;
  }
}
